import { combineReducers } from "@reduxjs/toolkit";
import appReducer from "./app/app.slice";
import langReducer from "./lang/langSlice";
import auhReducer from "./auth/authSlice";
import staffReducer from "features/staff/redux/staff.slice";
import roleReducer from "features/role/redux/role.slice";
import permissionReducer from "features/permission/redux/permission.slice";
import merchantReducer from "features/merchant/redux/merchant.slice";
import merchantRequestReducer from "features/merchant-request/redux/merchantRequest.slice";
import bannerReducer from "features/banner/redux/banner.slice";
import popupReducer from "features/popup/redux/popup.slice";

import storeReducer from "features/store/redux/store.slice";
import customerReducer from "features/customer/redux/customer.slice";
import brandReducer from "features/brand/redux/brand.slice";
import modelReducer from "features/model/redux/model.slice";
import newsReducer from "features/news/redux/news.slice";
import hotSaleReducer from "features/hot-sale/redux/hot-sale.slice";
import appointmentReducer from "features/appointment/redux/appointment.slice";
import carCareAppointmentReducer from "features/car-care-appointment/redux/car-care-appointment.slice";
import bookServiceReducer from "features/book-service/redux/bookService.slice";
import serviceReducer from "features/service/redux/service.slice";
import serviceCategoryReducer from "features/service-category/redux/serviceCategory.slice";
import showRoomReducer from "features/showroom/redux/showroom.slice";
import purchaseReducer from "features/purchase/redux/purchase.slice";
import categoryReducer from "features/category/redux/category.slice";
import carReducer from "features/cars/redux/car.slice";
import reasonCancelBookingReducer from "features/reason-cancel-booking/redux/reasonCancelBooking.slice";
import filterReducer from "store/filter/index.slice";
import notificationReducer from "features/notification/redux/notification.slice";
import notificationManageReducer from "features/notification-manage/redux/notification.slice";
import announcementReducer from "features/announcement/redux/announcement.slice";
import surveyAnswerReducer from "features/survey-answer/redux/survey-answer.slice";
import creatingCarsReducer from "features/cars/redux/creating-cars.slice";
import contactSupportReducer from "features/request-services/contact-support/redux/contact_support.slice";
import affiliateTransactionsReducer from "features/affiliate/transactions/redux/transactions.slice";
import collaboratorReducer from "features/affiliate/collaborators/redux/collaborator.slice";
import affiliatePaymentReducer from "features/affiliate/payment/redux/payment.slice";
import postReducer from "features/community/post/redux/post.slice";
import loyaltyCampaignReducer from "features/loyalty/campaign/redux/campaign.slice";
import loyaltyVoucherReducer from "features/loyalty/voucher/redux/voucher.slice";
import ratingReducer from "features/rating/redux/ratingContent.slice";
import partTypeReducer from "features/part-type/redux/partType.slice";
import formRequestReducer from "features/webapp/form-request/redux/form-request.slice";
import investmentReducer from "features/webapp/investment/redux/investment.slice";
import {
	webappHorizontalBannerReducer,
	webappVerticalBannerReducer,
} from "features/banner/WEBAPP/redux/wepapp-banner.slice";
import auctionReducer from "features/auction/redux/auction.slice";
import subscriptionTransactionReducer from "features/subscription-transaction/redux/subscription-transaction.slice";
import subscriptionPackageState from "features/subscription-class/redux/subscription-package.slice";
import reconciliationReducer from "features/reconciliation/redux/reconciliation.slice";
import careerPostReducer from "features/webapp/recruitment/career-posts/redux/careerPost.slice";
import candidateReducer from "features/webapp/recruitment/candidates/redux/candidate.slice";
import carCareCategoryReducer from "features/car-care-category/redux/car-care-category.slice";
import carCareReducer from "features/car-care/redux/car-care.slice";
import partnerReducer from "features/partner/redux/partner.slice";
import surveyReducer from "features/survey/redux/survey.slice";
import accessoriesOrderReducer from "features/accessories-order/redux/accessories-order.slice";
import commissionPolicyReducer from "features/affiliate/commission-policy/redux/commission-policy.slice";
import conversionReducer from "features/affiliate/conversion/redux/conversion.slice";
import { saleStaffReducer } from "features/sale-staffs/redux/sale-staff.slice";

const rootReducer = combineReducers({
	app: appReducer,
	lang: langReducer,
	auth: auhReducer,
	staff: staffReducer,
	role: roleReducer,
	permission: permissionReducer,
	merchant: merchantReducer,
	merchantRequest: merchantRequestReducer,
	banner: bannerReducer,
	store: storeReducer,
	customer: customerReducer,
	brand: brandReducer,
	model: modelReducer,
	news: newsReducer,
	hotSale: hotSaleReducer,
	appointment: appointmentReducer,
	carCareAppointment: carCareAppointmentReducer,
	service: serviceReducer,

	serviceCategory: serviceCategoryReducer,
	bookService: bookServiceReducer,
	showroom: showRoomReducer,
	purchase: purchaseReducer,
	category: categoryReducer,
	car: carReducer,
	reasonCancelBooking: reasonCancelBookingReducer,
	filter: filterReducer,
	notification: notificationReducer,
	notificationManage: notificationManageReducer,
	announcement: announcementReducer,
	surveyAnswer: surveyAnswerReducer,
	creatingCars: creatingCarsReducer,
	popup: popupReducer,
	contactSupport: contactSupportReducer,
	affiliateTransaction: affiliateTransactionsReducer,
	collaborator: collaboratorReducer,
	affiliatePayment: affiliatePaymentReducer,
	post: postReducer,
	campaign: loyaltyCampaignReducer,
	voucher: loyaltyVoucherReducer,
	rating: ratingReducer,
	partType: partTypeReducer,
	formRequest: formRequestReducer,
	investment: investmentReducer,
	webappBannerHorizontal: webappHorizontalBannerReducer,
	webappBannerVertical: webappVerticalBannerReducer,
	auction: auctionReducer,
	subscriptionTransaction: subscriptionTransactionReducer,
	subscriptionPackage: subscriptionPackageState,
	reconciliation: reconciliationReducer,
	careerPost: careerPostReducer,
	candidate: candidateReducer,
	carCareCategory: carCareCategoryReducer,
	carCare: carCareReducer,
	partner: partnerReducer,
	survey: surveyReducer,
	accessoriesOrder: accessoriesOrderReducer,
	commissionPolicy: commissionPolicyReducer,
	conversion: conversionReducer,
	saleStaff: saleStaffReducer,
});

export default rootReducer;
